import { createSlice } from "@reduxjs/toolkit";
import { put } from "redux-saga/effects";
import SagaRegistryHelper from "./SagaRegistry";
import ReducerRegistryHelper from "./ReducerRegistry";
import { encode, decode } from "base-64";
import dayjs from "dayjs";
import Random from "randomstring";
import { axios } from "./axios";
const DATE_FORMAT = 'ddd, DD-MMM-YY';
const DATE_FORMAT_FULLYEAR = 'ddd, DD-MMM-YYYY';
const DATE_FORMAT_24 = 'ddd, DD-MMM-YY, HH:mm';
const DATE_FORMAT_FULLYEAR_24 = 'ddd, DD-MMM-YYYY, HH:mm';

const initialState = { notification: null, loading: false, fullLoading: false, progressTokens: [] }

const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    setAlert: (state, actions) => {
      state.notification = actions.payload
    },
    setLoading: (state, actions) => {
      state.loading = actions.payload
    },
    setFullLoading: (state, actions) => {
      state.fullLoading = actions.payload
    },
    startProgress: (state, actions) => {
      state.progressTokens = [actions.payload, ...state.progressTokens]
    },
    stopProgress: (state, actions) => {
      const progressTokens = [...state.progressTokens]
      let index = progressTokens.indexOf(actions.payload);
      if (index > -1) {
        progressTokens.splice(index, 1)
      }
      state.progressTokens = [...progressTokens]
    }
  }
})
const actions = appSlice.actions;

export function* setAlertAndLoading(isLoading = null, alert = null, fullLoading = null) {
  if (alert !== null) {
    alert.severity = alert.success === false ? 'error' : 'success';
    yield put(actions.setAlert(alert));
  }
  if (isLoading !== null) {
    yield put(actions.setLoading(isLoading));
  }
  if (fullLoading !== null) {
    yield put(actions.setLoading(fullLoading));
  }
}
export const fetchS3ObjectAsBlob = (url) => {
  return fetch(axios.getFullPath('/incidents/s3_download_decrypt_file'), {
    method: "POST",
    body: JSON.stringify({ url }),
    headers: {...axios.getAuthTokenHeader(), "Content-Type": "application/json"}
  })
    .then((res) => {
      return res.blob()
    })
}
function* onSagaErrorCatch(error, errorMsg) {
  let alert;
  error = typeof error == "string" ? JSON.parse(error) : error;
  if (errorMsg) {
    alert = { success: false, message: errorMsg }
  } else if (error.data && error.data.message) {
    alert = { success: false, message: (error.data && error.data.message) || 'Request Failed' }
  }
  if (alert) {
    yield setAlertAndLoading(false, alert, false)
  }
}
export function* requestHandler(callback, errorMsg, showPregress = true) {
  let token = Random.generate(8);
  try {
    if (showPregress) {
      yield put(actions.startProgress(token))
    }
    yield callback()
    if (showPregress) {
      yield put(actions.stopProgress(token))
    }
  } catch (error) {
    console.log('requestHandler', error);
    yield onSagaErrorCatch(error, errorMsg);
    if (showPregress) {
      yield put(actions.stopProgress(token))
    }
  }
}
export * from "./axios";
export const SagaRegistry = new SagaRegistryHelper();
export const ReducerRegistry = new ReducerRegistryHelper();
export const AppActions = actions;
ReducerRegistry.register('app', appSlice.reducer);

const getState = (state) => state.app;
const extractStringByRegex = (regex, string) => {
  const match = regex.exec(string);
  return match && match[1] ? match[1] : ''
}
export const isLoading = (state) => {
  const _state = getState(state);
  return _state.loading
}
export const getFullLoading = (state) => {
  const _state = getState(state);
  return _state.fullLoading
}
export const getAlert = (state) => {
  const _state = getState(state);
  return _state.notification
}
export const isProgress = (state) => {
  const _state = getState(state);
  return _state.progressTokens.length > 0
}
export const getDayjs = (iDate) => {
  return dayjs(iDate)
}
export const getDateInFormat = (iDate, format) => {
  return getDayjs(iDate).format(format || DATE_FORMAT)
}
export const getDateIn24Format = (iDate) => {
  return getDayjs(iDate).format(DATE_FORMAT_24)
}
export const getDateInFullYearIn24Format = (iDate) => {
  return getDayjs(iDate).format(DATE_FORMAT_FULLYEAR_24)
}
export const getDateInFullYearFormat = (iDate) => {
  return getDayjs(iDate).format(DATE_FORMAT_FULLYEAR)
}
export const isDayjsObject = (iDate) => {
  return dayjs.isDayjs(iDate)
}
export const getUserDetails = (obj, attribute) => {
  if ((attribute ? obj[attribute] : obj)) {
    const { firstname, lastname, designation, department_name, country_code } = attribute ? obj[attribute] : obj;
    attribute = attribute || ''
    let creator = `${firstname} ${lastname || ''}`;
    if (obj) {
      obj[attribute + '_listname'] = `${firstname} ${lastname && lastname.length > 0 ? lastname[0] : ''}`;
      obj[attribute + '_designation'] = `${obj[attribute + '_listname']}, ${designation} - ${department_name}`
      obj[attribute + '_name'] = creator;
      obj.country_code_Num = country_code ? extractStringByRegex(/\(([^)]+)\)/, country_code) : ''
    }
  }
}
export const dateSorter = (attribute, itemA, itemB) => {
  const isAfter = dayjs(itemA[attribute]).isAfter(itemB[attribute])
  const isBefore = dayjs(itemB[attribute]).isAfter(itemA[attribute])
  return isAfter ? -1 : (isBefore ? 1 : 0)
}
export const encyptDataObject = (iData) => {
  let parsed = JSON.stringify(iData);
  parsed = encode(parsed);
  return parsed;
}
export const decryptDataObject = (iDataString) => {
  let decoded = decode(iDataString);
  decoded = JSON.parse(decoded);
  return decoded;
}
export const sortByProperty = (attribute, itemLeft, itemRight) => {
  let leftVal = itemLeft[attribute] ? itemLeft[attribute].toLowerCase() : '';
  let rightVal = itemRight[attribute] ? itemRight[attribute].toLowerCase() : '';
  return (leftVal < rightVal) ? -1 : (rightVal > leftVal ? 1 : 0)
}